import Router from './Router.jsx';

const App = () => <Router />;

export default App;
